import request from '@/utils/request'

export function login (data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function getInfo () {
  const ret = request({
    url: '/auth/check',
    method: 'get'
  })
  ret.catch(() => console.error('User not logged'))
  return ret
}

export function getConfig() {
  const ret = request({
    url: '/config',
    method: 'get'
  })
  return ret  
}

export function logout () {
  return request({
    url: '/auth/logout',
    method: 'delete'
  })
}

export function forgotPass (data) {
  return request({
    url: '/auth/forgotPass',
    method: 'post',
    data
  })
}

export function confirmForgotPass (data) {
  return request({
    url: '/auth/confirmForgotPass',
    method: 'post',
    data
  })
}

export function changePass (data) {
  return request({
    url: '/auth/changePass',
    method: 'post',
    data
  })
}

export function updateAccountProtocols (account_id, site_id, protocol_ids) {
  return request({
    url: '/protocol/associate/' + account_id,
    method: 'put',
    data: { protocol_ids, site_id }
  })
}